export enum Nips {
  Search = 50,
  GetMatchingEventIds = 114,
}
